import React from 'react';
import { cn } from '@/lib/utils'; // Assuming you have a utility for class names

interface AskCyraLabelProps {
  promptText: string;
  chatTitle: string; // New prop for the desired conversation title
  onAsk: (prompt: string, chatTitle: string) => void; // Modified onAsk to include chatTitle
  displayText?: string;
  className?: string;
  icon?: React.ReactNode; // Optional icon
}

const AskCyraLabel: React.FC<AskCyraLabelProps> = ({
  promptText,
  chatTitle,
  onAsk,
  displayText = "Ask Cyra",
  className,
  icon,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent triggering other click events on parent elements
    onAsk(promptText, chatTitle);
  };

  return (
    <span
      onClick={handleClick}
      className={cn(
        "text-xs text-primary hover:underline cursor-pointer inline-flex items-center gap-1",
        className
      )}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(e as any);}}
      title={`Click to ask Cyra: "${promptText.length > 50 ? promptText.substring(0, 47) + '...' : promptText}"`}
    >
      {icon}
      {displayText}
    </span>
  );
};

export default AskCyraLabel;